import { FC, SyntheticEvent } from 'react';
import { Popover, popoverClasses, PopoverProps, styled, Typography } from '@mui/material';

import { ConfirmComponentProps } from '../useConfirmBase';

export type ConfirmPopoverProps = ConfirmComponentProps &
  Pick<PopoverProps, 'anchorOrigin' | 'transformOrigin'> & {
    anchor: HTMLElement | null;
  };

const StyledPopover = styled(Popover)`
  .${popoverClasses.paper} {
    width: 400px;
  }
`;

const ConfirmPopover: FC<ConfirmPopoverProps> = ({
  open,
  prompt,
  anchor,
  onCancel,
  children,
  ...rest
}) => (
  <StyledPopover
    anchorEl={anchor}
    onClose={(e: SyntheticEvent) => {
      e?.stopPropagation();
      onCancel?.();
    }}
    open={open}
    {...rest}
  >
    <Typography p={1.5} variant='body1'>
      {prompt}
    </Typography>

    {children}
  </StyledPopover>
);

export default ConfirmPopover;
